import * as React from 'react';
import Box from '@mui/material/Box';
import Drawer from '@mui/material/Drawer';
import AppBar from '@mui/material/AppBar';
import CssBaseline from '@mui/material/CssBaseline';
import Toolbar from '@mui/material/Toolbar';
import List from '@mui/material/List';
import Typography from '@mui/material/Typography';
import Divider from '@mui/material/Divider';
import ListItem from '@mui/material/ListItem';
import ListItemButton from '@mui/material/ListItemButton';
import ListItemIcon from '@mui/material/ListItemIcon';
import ListItemText from '@mui/material/ListItemText';
import InboxIcon from '@mui/icons-material/MoveToInbox';
import MailIcon from '@mui/icons-material/Mail';
// import { useMediaQuery } from "@mui/material";
import { Link } from "react-router-dom";
import DrawerComponent from './Drawer';
import { Outlet } from 'react-router-dom';
import { makeStyles } from '@mui/styles';
import LabelOutlinedIcon from '@mui/icons-material/LabelOutlined';
import { useTheme } from '@mui/material/styles';
import PaymentOutlinedIcon from '@mui/icons-material/PaymentOutlined';
// redux
import { useSelector, useDispatch } from 'react-redux';

import { isRepManager } from '@util/helper';
import CalendarMonthOutlinedIcon from '@mui/icons-material/CalendarMonthOutlined';
import ClassOutlinedIcon from '@mui/icons-material/ClassOutlined';
import WorkHistoryOutlinedIcon from '@mui/icons-material/WorkHistoryOutlined';
import UpcomingOutlinedIcon from '@mui/icons-material/UpcomingOutlined';
import EventRepeatOutlinedIcon from '@mui/icons-material/EventRepeatOutlined';
import CastForEducationOutlinedIcon from '@mui/icons-material/CastForEducationOutlined';
import CoPresentOutlinedIcon from '@mui/icons-material/CoPresentOutlined';
import ManageAccountsOutlinedIcon from '@mui/icons-material/ManageAccountsOutlined';
import HailOutlinedIcon from '@mui/icons-material/HailOutlined';
import AnnouncementOutlinedIcon from '@mui/icons-material/AnnouncementOutlined';
import SendOutlinedIcon from '@mui/icons-material/SendOutlined';
import ChairAltOutlinedIcon from '@mui/icons-material/ChairAltOutlined';
// import logo from '@images/logo-tns.png'
import logo from '@images/logo_white.png'
import Avatar from '@mui/material/Avatar';
import useStyles from '@hooks/useStyles'
import CommonDrawer from '@components/CommonDrawer'
import TextsmsOutlinedIcon from '@mui/icons-material/TextsmsOutlined';
import GridOnOutlined  from '@mui/icons-material/GridOnOutlined';
import SavingsOutlined  from '@mui/icons-material/SavingsOutlined';
const mainColor = '#33c058'
const drawerWidth = 240;

export default function TeacherDrawer() {
  const classes = useStyles();
  const theme = useTheme();
  // const isMobile = useMediaQuery(theme.breakpoints.down("md"));
  const isMobile = false
  
  // redux
  const codeGroups = useSelector(state => state.codeGroupReducer)
  const codes = useSelector(state => state.codeReducer)
  const schools = useSelector(state => state.schoolReducer)
  const account = useSelector(state => state.accountReducer)
  const schola = useSelector(state => state.scholaReducer)

  const defIcon = <LabelOutlinedIcon size='small' sx={{color:'#212121'}}/>
  const defSx = {color:'#212121', fontSize:20}
  const primaryTypographyProps = (index) => {
    return {
      style: {
        fontSize:14, 
        fontFamily: ['JejuGothic', 'sans-serif'],
        color: activeIdx === index ? theme.palette.primary.main : '#212121',
        fontWeight:activeIdx === index ? 'bold' : 'normal'
      }

    }
  }
  const sideMenu = [
    // {text:'Test',     to:'/scm/test'},
    {text:'divider', visible: true},
    {text:'일정',   to:'/teacher/schedule', visible: true, icon:<CalendarMonthOutlinedIcon size='small' sx={defSx}/> },
    {text:'divider', visible: true},
    {text:'학기',     to:'/teacher/smst' , visible: true, icon:<EventRepeatOutlinedIcon size='small' sx={defSx}/> },
    {text:'강좌',     to:'/teacher/lecture', visible: true, icon:<CastForEducationOutlinedIcon size='small' sx={defSx}/>},
    {text:'수강신청',   to:'/teacher/regi' , visible: true, icon:<HailOutlinedIcon size='small' sx={defSx}/>},
    {text:'출석현황',     to:'/teacher/attdnc', visible: true, icon:<ChairAltOutlinedIcon size='small' sx={defSx}/>},
    {text:'divider', visible: true},

    {text:'공지사항',   to:'/teacher/notice' , visible: true, icon:<AnnouncementOutlinedIcon size='small' sx={defSx}/>},
    {text:'divider', visible: true},
    {text:'푸시 메시지',     to:'/teacher/message', visible: true, icon:<SendOutlinedIcon size='small' sx={defSx}/>},
    {text:'divider', visible: true},
  ]

  
  return (
    <CommonDrawer sideMenu={sideMenu} title={schola.name} barBgColor={'#2196f3'} menuIdx={6}/>
  );
}
